module.exports = __webpack_public_path__ + "front/img/kv.c91c213d.png";